import apiClient from "../authentication/utils/core/axios";

/**
 * Notifications API Service
 */
const NotificationsAPI = {
  fetchAll: async (userId) => {
    const response = await apiClient.get(`/users/${userId}/notifications/`);
    return response.data;
  },

  send: async (userId, notificationData) => {
    const response = await apiClient.post(`/users/${userId}/notifications/`, notificationData);
    return response.data;
  },

  markSingleRead: async (userId, notificationId) => {
    await apiClient.post(`/users/${userId}/notifications/${notificationId}/mark_read`);
    return { userId, notificationId };
  },

  markAllRead: async (userId) => {
    await apiClient.post(`/users/${userId}/notifications/mark_all_read`);
    return { userId };
  },

  getUnreadCount: async (userId) => {
    const response = await apiClient.get(`/users/${userId}/notifications/unread-count`);
    return response.data.unread_count;
  }
};

export default NotificationsAPI